import { useState } from "react";
import { useTranslation } from "react-i18next";

interface MaintenanceTitleProps {
  maintenanceTitles: { ar: string; en: string };
  onChange: (newValues: { ar: string; en: string }) => void;
}

function MaintenanceTitle({
  maintenanceTitles,
  onChange,
}: MaintenanceTitleProps) {
    const { t,i18n } = useTranslation();
  const locale = i18n.language
  const initialInputValue = locale === "ar" ? "ar": "en" 
  const [maintenanceTitleLang, setMaintenanceTitleLang] = useState<"ar" | "en">(
    initialInputValue,
  );

  const handleMaintanenceTitleChange =
    (lang: "ar" | "en") => (e: React.ChangeEvent<HTMLInputElement>) => {
      const updatedMaintenanceTitles = {
        ...maintenanceTitles,
        [lang]: e.target.value,
      };
      onChange(updatedMaintenanceTitles);
    };

  const handleMaintenanceTitleLangChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setMaintenanceTitleLang(e.target.value as "ar" | "en");
  };

  return (
    <div className="relative flex h-12 w-full items-start justify-start overflow-hidden rounded-md border border-gray-300">
      {/* Inputs for Arabic and English */}
      <div
        className={`h-full ${maintenanceTitleLang === "ar" ? "block w-full" : "hidden"}`}
      >
        <input
          name="maintenanceTitleAr"
          id="maintenanceTitleAr"
          className="h-full w-full rounded-md p-2 pe-[5rem]"
          type="text"
          placeholder={t("maintananceTitle.arabic") as string}
          value={maintenanceTitles.ar}
          onChange={handleMaintanenceTitleChange("ar")}
        />
      </div>

      <div
        className={`h-full ${maintenanceTitleLang === "en" ? "block w-full" : "hidden"}`}
      >
        <input
          name="maintenanceTitleEn"
          id="maintenanceTitleEn"
          className="h-full w-full rounded-md p-2 pe-[5rem]"
          type="text"
          placeholder={t("maintananceTitle.english") as string}
          value={maintenanceTitles.en}
          onChange={handleMaintanenceTitleChange("en")}
        />
      </div>

      {/* Language Selector */}
      <select
        className="absolute end-0 top-0 h-full w-[4rem] rounded-md"
        name="maintenanceTitle-lang"
        value={maintenanceTitleLang}
        onChange={handleMaintenanceTitleLangChange}
      >
        <option value="ar">AR</option>
        <option value="en">EN</option>
      </select>
    </div>
  );
}

export default MaintenanceTitle;
